module.exports = __webpack_public_path__ + "static/media/stock-store.3fa2e22a.svg";